import { ChevronRightIcon } from '@/components/icons/svg/ChevronRight';
import { useLocalization } from '@/data/Localization';
import { Box, Card, Divider, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { siteMapSX } from '../styles/siteMapSX';

interface Props {
	isSticky: boolean;
	hasDepartments: boolean;
	hasOtherSections: boolean;
	handleGoDepartments: () => void;
	handleGoSections: () => void;
}

export const SiteMapNavigate = ({
	isSticky,
	hasDepartments,
	hasOtherSections,
	handleGoDepartments,
	handleGoSections,
}: Props) => {
	const localization = useLocalization('SiteMap');

	return (
		<Card
			sx={
				{
					...siteMapSX.navigateCard,
					...(isSticky ? siteMapSX.navigateBorder : {}),
				} as SxProps<Theme>
			}
			elevation={0}
		>
			<Typography variant="body1" sx={siteMapSX.navigateLegend} component="p">
				{localization.navigateThroughSite.t()}
			</Typography>

			<Divider sx={{ borderColor: 'grey.50' }} />

			<Box display="flex">
				{hasDepartments && (
					<Box sx={siteMapSX.navigateLink} onClick={handleGoDepartments}>
						<Typography sx={siteMapSX.navigateLinkText}>
							{localization.departmentsAZ.t()}
						</Typography>
						<ChevronRightIcon sx={siteMapSX.chevronIcon} />
					</Box>
				)}

				{hasOtherSections && (
					<Box sx={{ ...siteMapSX.navigateLink, ml: 4 }} onClick={handleGoSections}>
						<Typography sx={siteMapSX.navigateLinkText}>
							{localization.otherSections.t()}
						</Typography>
						<ChevronRightIcon sx={siteMapSX.chevronIcon} />
					</Box>
				)}
			</Box>
		</Card>
	);
};
